import React, {useEffect} from 'react';
import SPSelectWithEnum from "../../../base/SPSelectWithEnum";
import {Form} from "antd";
import emiter, {_EVENTS} from "../../../../../events";
interface PropsType {
    enums: any
}


const ServiceTypeAggregation: React.FC<PropsType> = (props) => {
    const { enums } = props

    const form:any = Form.useFormInstance();
    const initialCompensationEnum = enums['f_price_service_types']
    const maintenanceAmountEnum = enums['f_feprecia_service_types']


    const onChange = (e: any) => {
        const initialCompensationObj = initialCompensationEnum?.find((item: any) => item.key === e) || {}
        const maintenanceAmountObj = maintenanceAmountEnum?.find((item: any) => item.key === e) || {}
        const data: any = form?.getFieldValue()
        const depreciateObj = data.depreciate || {}
        form?.setFieldsValue({
            ...data,
            level: e,
            contains_tyres_loss: ([3] as any).includes(e) ? 1 : null,
            contains_glass_loss: ([2, 3] as any).includes(e) ? 1 : null,
            guarantee_deductible_amount: isNaN(Number(initialCompensationObj.value)) ? null : Number(initialCompensationObj.value),
            depreciate: Object.assign(depreciateObj, {
                amount: isNaN(Number(maintenanceAmountObj.value)) ? null : Number(maintenanceAmountObj.value),
            }),
        })
        emiter.emit(_EVENTS.PRODUCT_PRICE.VALUE_ADDED_PRICE.CHANGE_LEVEL, e)
    }

    useEffect(() => {
        setTimeout(() => {
          emiter.emit(_EVENTS.PRODUCT_PRICE.VALUE_ADDED_PRICE.CHANGE_LEVEL, form?.getFieldValue('level') || null)
        }, 300)
    }, [])



    return (
        <SPSelectWithEnum
            {...props}
            style={{
                width: '300px' }}
            onChange={onChange}
            enums={enums}
            enumKey={'guarantee_rule_level'}>
        </SPSelectWithEnum>
    )
}

export default ServiceTypeAggregation;


